import api from '../../service/api';
import { useState, useEffect, useContext } from 'react';
import {
    IconButton, List, ListItem, Typography, Tooltip, Box, Stack
} from '@mui/material';
import { useParams, useHistory } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ProgressBar from '../progress/progressBar';
import HomeIcon from '@mui/icons-material/Home';
import CONSTANT from '../../Constant/Constant';
import SingleValue from '../detail-page/base/single-value';
import { DirectionContext } from '../../context/DirectionProvider';

const TrackSubscription = (props) => {

    const [subscribedDetail, setSubscribedDetail] = useState([]);
    const [updatedValue, setupdatedValue] = useState([]);
    const history = useHistory();
    const [progressFlag, setProgressFlag] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);
    let { id } = useParams();     
    const direction = useContext(DirectionContext);

    const goToHome = () => {
        props.history.push('/');
    }

    const goBack = () => {
        props.history.goBack();
    }

    /**
     * get status color class
     * @param {*} state 
     * @returns 
     */
    const getStatusClass = (state) => {
        switch (state) {
            case CONSTANT.STATE[0]:
                return 'text-white rounded py-2 px-3 bg-primary float-end';
            case CONSTANT.STATE[1]:
                return 'text-white rounded py-2 px-3 bg-success float-end';
            case CONSTANT.STATE[2]:
                return 'text-white rounded py-2 px-3 bg-danger float-end';
            case CONSTANT.STATE[3]:
                return 'text-white rounded py-2 px-3 bg-warning float-end';
            case CONSTANT.STATE[4]:
                return 'text-white rounded py-2 px-3 bg-primary float-end';
            case CONSTANT.STATE[5]:
                return 'text-white rounded py-2 px-3 bg-success float-end';
            case CONSTANT.STATE[6]:
                return 'text-white rounded py-2 px-3 bg-danger float-end';
            case CONSTANT.STATE[7]:
                return 'text-white rounded py-2 px-3 bg-success float-end';
            case CONSTANT.STATE[8]:
                return 'text-white rounded py-2 px-3 bg-warning float-end';
            case 'AWAITING_REVIEW':
                return 'text-white rounded py-2 px-3 bg-primary float-end';
            case CONSTANT.STATE[9]:
                return 'text-white rounded py-2 px-3 bg-success float-end';
            default:
                return 'text-white rounded py-2 px-3 bg-primary float-end';
        }
    }


    useEffect(() => {
        
        setProgressFlag(true);

        api.getAllRequest(false, null, id).then((res) => {         
            setSubscribedDetail(res.data)
            setupdatedValue(res.data.updatedValue)

            setProgressFlag(false)
            setLoading(false)
        }).catch((error) => {
            setErrorFlag(true);
            let errorDetail = error;
            let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
            setProgressFlag(false)
        })   
    
    
    },[])



    return (
        <section className={"container w-80 body-height extra-margin-top-less"}>
            {
                progressFlag
                &&
                <div className="d-flex justify-content-center extra-margin-top">
                    <ProgressBar />
                </div>
            }

            {
                !progressFlag && !errorFlag
                &&
                <>
                    <div className='container'>
                        {
                            !progressFlag
                            &&
                            <>
                                {
                                    <div className='row mt-5 mb-5'>
                                        <Stack direction={'row'} justifyContent={'space-between'}>
                                            <Tooltip disableFocusListener title="Back" id="tooltip">
                                                <IconButton aria-label="back"
                                                    className="text-danger"
                                                    onClick={goBack} color="secondary">
                                                    <ArrowBackIcon sx={{transform: direction ==='rtl'?'rotate(180deg)':''}} />
                                                </IconButton>
                                            </Tooltip>
                                            <IconButton aria-label="home" onClick={goToHome}
                                                color="secondary">
                                                <Tooltip disableFocusListener title="Return To Home" id="tooltip">
                                                    <HomeIcon className="text-danger "
                                                    />
                                                </Tooltip>
                                            </IconButton>
                                        </Stack>
                                        <Stack 
                                            direction={'row'} 
                                            justifyContent={'space-between'} 
                                            alignItems={'center'}
                                            margin={'10px 0px'}
                                        >
                                            <Typography id="requested-change">
                                                Requested Changes
                                            </Typography>
                                            <span data-wg-notranslate className={getStatusClass(subscribedDetail.requestStatus)}>
                                                {subscribedDetail.requestStatus  === 'AWAITING_REVIEW' ? 'AWAITING REVIEW': subscribedDetail.requestStatus} 
                                            </span>
                                        </Stack>
                                        <Box border="1px solid black" width="800px" mt={4}>
                                        <List component="div" className='row'>
                                            {
                                                <>
                                                    <ListItem className='col-6'>
                                                        <SingleValue label={'Request Id'} value={[{ value: subscribedDetail.Id }]} />
                                                    </ListItem>
                                                    {subscribedDetail.CreatedBy && <ListItem className='col-6'>
                                                        <SingleValue label={'Requestor Id'} value={[{ value: subscribedDetail.CreatedBy }]} />
                                                    </ListItem>}
                                                    {subscribedDetail.RequestorName && <ListItem className='col-6'>
                                                        <SingleValue label={'Requestor Name'} value={[{ value: subscribedDetail.RequestorName.includes(" - Network") ? subscribedDetail.RequestorName.split(" - Network")[0].trim() : subscribedDetail.RequestorName }]} />
                                                    </ListItem>}
                                                     {(subscribedDetail.RequestorEmail || subscribedDetail.UserEmail) && <ListItem className='col-6'>
                                                        <SingleValue label={'Requestor Email'} value={[{ value: subscribedDetail.RequestorEmail || subscribedDetail.UserEmail }]} />
                                                    </ListItem>}
                                                    <ListItem className='col-6'>
                                                        <SingleValue label={'Created Time'} value={[{ value: subscribedDetail.CreatedDate }]} />
                                                    </ListItem>
                                                    <ListItem className='col-6'>
                                                        <SingleValue label={'Updated Time'} value={[{ value: subscribedDetail.UpdatedDate }]} />
                                                    </ListItem>
                                                    <ListItem className='col-6'>
                                                        <SingleValue label={'Vendor'} value={[{ value: subscribedDetail.VendorName }]} />
                                                    </ListItem>
                                                    <ListItem className='col-6'>
                                                        <SingleValue label={'OneKey Id'} value={[{ value: updatedValue.onekeyEid }]} />
                                                    </ListItem>
                                                    <ListItem className='col-6'>
                                                        <SingleValue label={'Entity Type'} value={[{ value: subscribedDetail?.EntityType || "Individual"}]} />
                                                    </ListItem>
                                                    <ListItem className='col-6'>
                                                        <SingleValue label={'First Name'} value={[{ value: updatedValue.firstName }]} />
                                                    </ListItem>
                                                    <ListItem className='col-6'>
                                                        <SingleValue label={'Last Name'} value={[{ value: updatedValue.lastName }]} />
                                                    </ListItem>
                                                </>
                                            }
                                        </List>
                                        </Box>
                                    </div>
                                }
                            </>
                        }
                    </div>
                </>
            }
        </section>

    );

}

export default TrackSubscription;